import * as variables from './variables.js';

import {Analytics} from '@plaudit/analytics';
Analytics.getInstance();

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import './component/menu.service';

import Forms from './component/Forms';
Forms.init();

// Adds classes to body as we scroll
import Scrolled from './component/Scrolled';
new Scrolled({
	scrolledClass: 'hasScrolled',
	scrolledDistanceClass: 'hasScrolledDistance',
	scrollDistanceDown: 200,
	scrollDistanceUp: 20
});
// ===============================================================

// Team Listing Functionality
import TeamLanding from './component/TeamLanding';
new TeamLanding({
	team: '.teamListing',
	styleClass: {
		items: '.teamListing__item',
		links: '.teamMember__fullLink',
		bios: '.teamListing__bio'
	}
});
// ===============================================================

// @ts-ignore
var Accordion = require('./component/Accordion/Accordion.js');
var sectionAccordion = new Accordion({
	scope: '.accordionGroup'
});
sectionAccordion.activate();
// ===============================================================

// @ts-ignore
var GeneralMap = require('./component/GeneralMap/GeneralMap.js');
GeneralMap.init('.contactVcard__map', '.addressFormat--US');
// ===============================================================